import { render, staticRenderFns } from "./StudentPasswordResetComplete.vue?vue&type=template&id=da087e60&scoped=true&lang=pug&"
import script from "./StudentPasswordResetComplete.vue?vue&type=script&lang=ts&"
export * from "./StudentPasswordResetComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da087e60",
  null
  
)

export default component.exports